import { Card, Typography } from 'antd';
import { CloseOutlined, WarningOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

const { Title, Text } = Typography;

const alerts = [
  { name: 'Anshul Sharma', issue: 'Frequent Monday Absences' },
  { name: 'Vivek Singh', issue: 'Pattern of consecutive late arrivals' },
  { name: 'Amit Kumar', issue: 'Frequent Friday Absences' },
  { name: 'Abhishek Singh', issue: 'Multiple Correction request this month' },
];

const AlertBox = () => {

    const [isNotfication, setIsNotification] = useState(true)
  return (
        isNotfication &&
    <Card
      className="alert-box mb-10"
      bodyStyle={{ backgroundColor: '#fffbe6', padding: '16px 24px' }}
      bordered
      title={""}
      
    >
    <>

    
    <div className='flex mb-3 justify-between'>
            <div> <span className='text-2xl mb-4' style={{ color: '#BF9000', fontWeight: 'bold' }}>Alerts</span></div>
            <div onClick={() => setIsNotification(false)} className='cursor-pointer'><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipR  ule="evenodd" d="M9.5 17.8125C4.90912 17.8125 1.1875 14.0897 1.1875 9.5C1.1875 4.91031 4.90912 1.1875 9.5 1.1875C14.0909 1.1875 17.8125 4.91031 17.8125 9.5C17.8125 14.0897 14.0909 17.8125 9.5 17.8125ZM9.5 0C4.25303 0 0 4.25125 0 9.5C0 14.7487 4.25303 19 9.5 19C14.747 19 19 14.7487 19 9.5C19 4.25125 14.747 0 9.5 0ZM12.8945 6.10377C12.6605 5.8722 12.2823 5.8722 12.0484 6.10377L9.49645 8.65685L6.98131 6.13935C6.74915 5.90779 6.37272 5.90779 6.14175 6.13935C5.90959 6.37092 5.90959 6.75094 6.14175 6.98251L8.65689 9.49406L6.12395 12.0294C5.89061 12.2609 5.89061 12.6409 6.12395 12.8784C6.35789 13.11 6.73668 13.11 6.97062 12.8784L9.50355 10.3432L12.0187 12.8606C12.2508 13.0922 12.6273 13.0922 12.8588 12.8606C13.091 12.6291 13.091 12.2491 12.8588 12.0175L10.3431 9.50594L12.8945 6.95279C13.1278 6.71529 13.1278 6.34127 12.8945 6.10377Z" fill="#BF9000"/>
                </svg>
                </div>
        </div>
      
      {alerts.map((alert, idx) => (
        <div key={idx} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <WarningOutlined style={{ color: '#BF9000' }} />
          <Text style={{ color: '#BF9000' }}>
            <strong>{alert.name}:</strong> {alert.issue}
          </Text>
        </div>
      ))}
             </>
    </Card>

  );
};

export default AlertBox;
